<div class="modal-header py-1">
    <h5 class="modal-title">View Image</h5>
    <button type="button" style="zoom: 2.4;" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="height: 400px;">
    <img style="width: 450px !important;" [src] = "imageUrl">
</div>